import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=78d7a710&scoped=true&"
import script from "./prize.vue?vue&type=script&lang=js&"
export * from "./prize.vue?vue&type=script&lang=js&"
import style0 from "./prize.vue?vue&type=style&index=0&id=78d7a710&prod&lang=scss&"
import style1 from "./prize.vue?vue&type=style&index=1&id=78d7a710&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d7a710",
  null
  
)

export default component.exports